"use client";
import { Icon } from "@iconify/react";
import Image from "next/image";
import Link from "next/link";
import { useEffect, useState } from "react";

const GridMegaMenu = ({ menu }) => {
  const [activeItem, setActiveItem] = useState(null);
  const [isOpen, setIsOpen] = useState(false);

  // Set default active
  useEffect(() => {
    if (!menu?.megamenu_items?.length) return;

    const featured =
      menu.megamenu_items.find((item) => item.is_featured) ||
      menu.megamenu_items[0];

    setActiveItem(featured);
  }, [menu]);

  const handleLinkClick = () => {
    setIsOpen(false);
  };

  return (
    <div
      className="group"
      onMouseEnter={() => setIsOpen(true)}
      onMouseLeave={() => setIsOpen(false)}
    >
      <div className="mega-menu-nav text-[14px] font-semibold py-[25px] transition-colors duration-200 text-user-text group-hover:text-user-primary flex items-center gap-1 cursor-pointer relative">
        <div>{menu?.name}</div>
        <Icon
          icon="lucide:chevron-down"
          width="18"
          height="18"
          className="text-user-text group-hover:text-user-primary translate-y-0.5"
        />
        {/* arrow */}
        <div
          className="absolute bottom-[-19px] left-1/2 -translate-x-1/2 w-4 h-4 bg-white border-l-2 border-t-2 border-[rgba(45,45,45,0.10)] rotate-45 opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-30"
          style={{
            WebkitMaskImage:
              "linear-gradient(135deg, black 0%, black 50%, transparent 50%)",
            maskImage:
              "linear-gradient(135deg, black 0%, black 50%, transparent 50%)",
          }}
        />
      </div>

      <div
        className={`mega-menu-content absolute top-full left-0 w-full z-10 transition-all duration-300 origin-top mt-2.5 ${
          isOpen
            ? "opacity-100 scale-100 translate-y-0 pointer-events-auto"
            : "pointer-events-none opacity-0 scale-95 translate-y-2"
        }`}
      >
        <div className="mx-auto w-fit max-w-full bg-white border border-[rgba(45,45,45,0.10)] rounded-[16px] shadow-lg">
          <div className="absolute top-[-12px] left-0 w-full h-[12px] bg-transparent"></div>

          <div className="flex">
            <div className="mega-menu-left w-[883px] p-7.5">
              <h3 className="text-[12px] font-bold text-user-text uppercase mb-5">
                {menu?.megamenu_name}
              </h3>

              <div className="grid grid-cols-2 2xl:grid-cols-3 gap-3">
                {menu?.megamenu_items?.map((item, index) => (
                  <Link
                    key={index}
                    href={item.url}
                    onClick={handleLinkClick}
                    onMouseEnter={() => setActiveItem(item)}
                    className={`flex items-start gap-4 p-3 rounded-[8px] transition-all ${
                      activeItem?.id === item.id
                        ? "bg-[#F5F7F9]"
                        : "hover:bg-[#F5F7F9]"
                    }`}
                  >
                    <Image
                      src={item?.icon}
                      alt="icon"
                      width={24}
                      height={24}
                      className="w-[24px] h-[24px]"
                    />
                    <div>
                      <h4 className="text-[14px] font-bold text-user-text mb-1.5">
                        {item?.title}
                      </h4>
                      <p className="text-[13px] font-medium text-user-paragraph">
                        {item?.description}
                      </p>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GridMegaMenu;
